import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  iconGap: '0 0 0 8px',
  get smallPadding() {
    return theme.small.padding;
  },
  // invalid
  invalid: {
    get border() {
      return "1px solid " + theme.color.danger;
    }
  }
};
var editable;
setDefault(function () {
  editable = deepDefaults(theme, {
    editable: defaults
  }).editable;
  makeStyles == null || makeStyles.clearCache();
});
export { editable };
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("display:inline-flex;align-items:center;.", k, "-editable-icon{margin:", editable.iconGap, ";}&.", k, "-invalid{.", k, "-input-wrapper{border:", editable.invalid.border, "!important;}}");
});